var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"display-3 text-center"},[_vm._v(" Hoşgeldin ")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }